import type { SoftwareVersion } from "@/types";

export default function VersionHistory({ versions }: { versions: SoftwareVersion[] }) {
  return (
    <div className="relative">
      <div className="absolute left-[7px] top-2 bottom-2 w-px bg-background-200"></div>
      <ul className="space-y-5">
        {versions.map((v, i) => (
          <li key={`${v.version}-${v.date}`} className="relative pl-7">
            <span
              className={`absolute left-0 top-1.5 flex items-center justify-center w-4 h-4 rounded-full ${
                i === 0 ? "bg-primary-500" : "bg-background-300"
              }`}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-background-50"></span>
            </span>
            <div className="flex items-center gap-2.5 flex-wrap">
              <span className="text-sm font-heading font-semibold text-foreground-950">v{v.version}</span>
              {i === 0 && <span className="text-[11px] text-accent-700 bg-accent-100 rounded-full px-2 py-0.5">最新版本</span>}
              <span className="text-xs text-secondary-500">{v.date}</span>
            </div>
            <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{v.notes}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}